<template>
  <input type="color" :value="value" @change="handleColorChange" />
</template>

<script>
export default {
  name: 'OcColorPicker',
  props: {
    value: String,
  },
  data () {
    return {}
  },
  methods: {
    handleColorChange (e) {
      this.$emit('change', e.target.value)
    },
  },
}
</script>
